"use client"

import { ShoppingBasket } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ShoppingBasketIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ShoppingBasketIcon = component(Icon)({ as: ShoppingBasket })
